import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-cy": "protein-veggie" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_checklist = _resolveComponent("checklist")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_segment, {
      mode: "md",
      value: _ctx.selected,
      onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle($event.target.value)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_segment_button, {
          value: "protein",
          "data-cy": "button-protein",
          style: {"font-size":"1.3rem"}
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Proteins")
          ])),
          _: 1
        }),
        _createVNode(_component_ion_segment_button, {
          value: "veggies",
          "data-cy": "button-veggies",
          style: {"font-size":"1.3rem"}
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Veggies & More ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.availableTopping && _ctx.protein && _ctx.veg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.checklistClass, "px-m8"]),
          style: {"margin-top":"10px"}
        }, [
          (_ctx.selected === 'protein')
            ? (_openBlock(), _createBlock(_component_checklist, {
                key: 0,
                items: _ctx.protein,
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.protein = $event)),
                hideSplitOpts: _ctx.hideSplitOpts,
                "data-cy": "checklist-protein"
              }, null, 8, ["items", "hideSplitOpts"]))
            : (_openBlock(), _createBlock(_component_checklist, {
                key: 1,
                items: _ctx.veg,
                onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.veg = $event)),
                hideSplitOpts: _ctx.hideSplitOpts,
                "data-cy": "checklist-veggies"
              }, null, 8, ["items", "hideSplitOpts"]))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}